import { Switch, Route, Redirect } from 'react-router-dom';

import usePdvAccess from '@giro-pdv/hooks/usePdvAccess.hook';

import useProtectedByAuth from '@giro-pdv/hooks/useProtectedByAuth.hook';

import AppLayout from '@giro-pdv/layouts/App.layout';

import ROUTES from '@giro-pdv/constants/routes.constant';

import TransactionsScreen from './screens/ReportsEC.screen';
import ReportsCreaScreen from './screens/ReportsCrea.screen';
import ReportsFinancingScreen from './screens/ReportsFinancing.screen';
import ReportsSlips from './screens/ReportsSlips.screen';
import DialogSendSlipComponent from './components/DialogDetailSlips.component';

const ReportsModule = () => {
  useProtectedByAuth();

  const {
    isCrea,
    canAccessEcReports,
    canAccessFinancingReports,
    canManageSlips,
    reportsRootRoute,
  } = usePdvAccess();
  const ROOTROUTER = reportsRootRoute;

  return (
    <AppLayout>
      <Switch>
        {canAccessEcReports && (
          <Route
            exact
            path={ROUTES.REPORTS.EC}
            component={TransactionsScreen}
          />
        )}

        {canAccessFinancingReports && (
          <Route
            exact
            path={ROUTES.REPORTS.FINANCING}
            component={ReportsFinancingScreen}
          />
        )}

        {isCrea && (
          <Route
            exact
            path={ROUTES.REPORTS.CREA}
            component={ReportsCreaScreen}
          />
        )}

        {canManageSlips && (
          <Route exact path={ROUTES.REPORTS.SLIPS} component={ReportsSlips} />
        )}

        <Redirect to={ROOTROUTER} />
      </Switch>
      <DialogSendSlipComponent />
    </AppLayout>
  );
};

export default ReportsModule;
